import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const PrevBtnOutline = (props) => (
  <button className={`btn btn-link-primary`} {...props}>
    <ArrowBackIcon className="me-2" fontSize={'auto'} />
    {props.text}
  </button>
)

export default PrevBtnOutline;